export default "__VITE_ASSET__BiZwn_tq__"